exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UserExports__exports___2WDLm {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin-top: 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.UserExports__exports___2WDLm > *:last-child {\n  margin-left: 24px;\n}\n", ""]);

// exports
exports.locals = {
	"exports": "UserExports__exports___2WDLm"
};